import "./Contact.module.css";
import AutoMotiGalvene from "@/reusable_sections/Header";
import StartYourProject from "./sections/StartYourProject";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <AutoMotiGalvene />
      <StartYourProject />
      <Footer />
    </div>;
}